import CheckBoxComponent from '@/components/shared-components/check-box';
import RadioButtonComponent from '@/components/shared-components/radio-button';
import ScrollableContainerComponent from '@/components/shared-components/scrollable-container';
import ConnectionNotificationComponent from '@/components/shared-components/connection-notification';
import LoadingSpinnerComponent from '@/components/shared-components/loading-spinner';
import Vue, { VueConstructor } from 'vue';

const sharedComponents: { [key: string]: VueConstructor<Vue> } = {
  checkBox: CheckBoxComponent,
  radioButton: RadioButtonComponent,
  scrollableContainer: ScrollableContainerComponent,
  connectionNotification: ConnectionNotificationComponent,
  loadingSpinner: LoadingSpinnerComponent
};
export default sharedComponents;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/shared-components/index.ts